import React from 'react';
import LoginPage from './LoginPage';

// TagAlong Pro — the company-catered sign-in. It's the same auth as the
// consumer TagAlong login (same accounts, same server), just re-skinned for a
// business: TagAlong Pro wordmark, company copy, and a "Company name" field on
// sign-up. Reached at /pro (or ?pro). After sign-in the app runs as TagAlong
// with the Pro product config (no rentals).
export default function ProLoginPage({ onLoggedIn }) {
  return <LoginPage variant="pro" onLoggedIn={onLoggedIn} />;
}
